import { faSort } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  AdvancedSelect,
  Button,
  FormGroup,
  Input,
  Modal,
} from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useStyles from './SortModal.styles'

interface Option {
  label: string
  value: 'filename' | 'creation_date'
}

interface SortModalProps {
  order: string[]
  setOrder: React.Dispatch<React.SetStateAction<string[]>>
  direction: 'asc' | 'desc'
  setDirection: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>
}

const SortModal = ({
  order,
  setOrder,
  direction,
  setDirection,
}: SortModalProps) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const [isOpen, setOpen] = useState(false)

  const optionsOrderBy: Option[] = [
    { label: t('Name'), value: 'filename' },
    { label: t('Date'), value: 'creation_date' },
  ]

  const [tmpOrder, setTmpOrder] = useState<string[]>(order)
  const [tmpDirection, setTmpDirection] = useState<'asc' | 'desc'>(direction)

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        label={t('Sort')}
        icon={<FontAwesomeIcon icon={faSort} />}
        buttonType="button"
        type="blank-default"
      />
      {isOpen && (
        <Modal
          size="sm"
          onCloseRequest={() => setOpen(false)}
          title={t('Sort')}
          footer={
            <Button
              onClick={() => {
                // evito rendering se filtri non sono cambiati
                if (order !== tmpOrder) {
                  if (tmpOrder) {
                    setOrder(tmpOrder)
                  } else {
                    // se utente non seleziona nulla, ordina in base a creation_date
                    setOrder(['is_used_in_training', 'creation_date'])
                  }
                }
                if (direction !== tmpDirection) {
                  setDirection(tmpDirection)
                }
                setOpen(false)
              }}
              label={t('Set sort')}
              type="action"
              buttonType="button"
            />
          }
        >
          <div className={classes.container}>
            <AdvancedSelect
              name="orderByField"
              id="orderByFIeld"
              label={t('Order by')}
              placeholder={t('Select ...')}
              value={optionsOrderBy.find((o) => o.value === tmpOrder[1])}
              onChange={(v: Option | null) => {
                if (v) {
                  setTmpOrder(['is_used_in_training', v.value])
                } else {
                  setTmpOrder(['is_used_in_training'])
                }
              }}
              options={optionsOrderBy}
            />
            <FormGroup required>
              <Input
                name="Ascending"
                id="Ascending"
                label={t('Ascending')}
                type="radio"
                inline
                checked={tmpDirection === 'asc'}
                onChange={() =>
                  tmpDirection === 'desc'
                    ? setTmpDirection('asc')
                    : setTmpDirection('desc')
                }
                className="mr-2"
              />
              <Input
                name="Descending"
                id="Descending"
                label={t('Descending')}
                type="radio"
                inline
                checked={tmpDirection === 'desc'}
                onChange={() =>
                  tmpDirection === 'desc'
                    ? setTmpDirection('asc')
                    : setTmpDirection('desc')
                }
                className="ml-2"
              />
            </FormGroup>
          </div>
        </Modal>
      )}
    </>
  )
}

export default SortModal
